var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2903_6598)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 2.14844C21.2266 2.49219 20.2812 2.75 19.4219 2.83594C20.3672 2.23438 21.0547 1.375 21.3984 0.34375C20.5391 0.859375 19.5938 1.20312 18.5625 1.46094C17.7031 0.601562 16.5859 0 15.2969 0C12.8047 0 10.8281 2.0625 10.8281 4.46875C10.8281 4.8125 10.8281 5.15625 10.9141 5.5C7.04688 5.32812 3.78125 3.52344 1.54688 0.859375C1.11719 1.46094 0.945312 2.32031 0.945312 3.09375C0.945312 4.64062 1.71875 6.01562 2.92188 6.875C2.14844 6.875 1.46094 6.61719 0.859375 6.27344C0.859375 6.27344 0.859375 6.27344 0.859375 6.35937C0.859375 8.50781 2.40625 10.3984 4.46875 10.7422C4.125 10.8281 3.69531 10.9141 3.26562 10.9141C3.00781 10.9141 2.66406 10.9141 2.40625 10.8281C3.00781 12.6328 4.64062 13.9219 6.61719 13.9219C5.07031 15.125 3.09375 15.8125 1.03125 15.8125C0.6875 15.8125 0.34375 15.8125 0 15.7266C1.97656 17.0156 4.38281 17.7891 6.875 17.7891C15.2109 17.7891 19.6797 10.9141 19.6797 4.98438C19.6797 4.8125 19.6797 4.55469 19.6797 4.38281C20.625 3.86719 21.3984 3.00781 22 2.14844Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2903_6598"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.b8117b25b0e6c6e5e9137fe6ac162a0d.svg";
export { ForwardRef as ReactComponent };